 $(function () {
      console.log('ready works');
jQuery(' .attachment-points-item').on("click", function() {
     console.log('clicked');
   
                jQuery('.attachment-points-item').removeClass('active');
                jQuery(this).addClass('active');
                  var dataanchor =  jQuery(this).attr('data-anchor');
    console.log(dataanchor);
                  jQuery('.attachment_content').css("display","none");
                   jQuery('.attachment_content.'+dataanchor).css("display","block");

                    jQuery('.attachment_contentMob').css("display","none");
                   jQuery('.attachment_contentMob.'+dataanchor).css("display","block");

    });
  })